import { HttpClient } from '../utils/httpClient';

const PATH = {
    tag: '/client/sc/tag',
    group: '/client/sc/group',
    overview: '/client/sc/overview',
    lastReported: '/client/sc/last-reported',
    session: '/client/sc/session',
    cancelProfile: '/client/sc/cancel-profile',
    signal: '/client/sc/signal',
    sendChargingProfile: '/client/sc/send-charging-profile',
    chargerGroup: '/client/sc/charger-group',
    sessionLogs: '/client/sc/session/logs',
    lastSession: '/client/sc/last-session',
    rebalancingEvents: '/client/sc/rebalancing-events',
    siteOverview: '/client/sc/site-overview',
    chargingProfiles: '/client/sc/charging-profiles',
    charger: '/client/sc/chargers',
};

const CreateTag = (body, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.tag}`, body).then(callback).catch(error).finally(next);
};

const UpdateTag = (id, body, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.tag}/${id}`, body).then(callback).catch(error).finally(next);
};

const GetAllTags = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.tag}`, { params }).then(callback).catch(error).finally(next);
};

const DeleteTag = (id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.tag}/${id}`).then(callback).catch(error).finally(next);
};

const CreateGroup = (body, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.group}`, body).then(callback).catch(error).finally(next);
};

const UpdateGroup = (id, body, start, callback, error, next) => {
    start();
    return HttpClient.patch(`${PATH.group}/${id}`, body).then(callback).catch(error).finally(next);
};

const GetAllGroups = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.group}`, { params }).then(callback).catch(error).finally(next);
};

const DeleteGroup = (id, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.group}/${id}`).then(callback).catch(error).finally(next);
};

const Overview = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.overview}`, { params }).then(callback).catch(error).finally(next);
};

const LastReported = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.lastReported}`, { params }).then(callback).catch(error).finally(next);
};

const GetSessionsData = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.session}`, { params }).then(callback).catch(error).finally(next);
};

const FetchSessionInfo = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.session}/${id}`, { params }).then(callback).catch(error).finally(next);
};

const CancelProfile = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.delete(`${PATH.cancelProfile}/${id}`, { params }).then(callback).catch(error).finally(next);
};

const GetSignals = (start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.signal}`).then(callback).catch(error).finally(next);
};

const SendChargingProfile = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.post(`${PATH.sendChargingProfile}/${id}`, {}, { params }).then(callback).catch(error).finally(next);
};

const GetChargerGroup = (id, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.chargerGroup}/${id}`).then(callback).catch(error).finally(next);
};

const GetLogs = (id, params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.sessionLogs}/${id}`, { params }).then(callback).catch(error).finally(next);
};

const GetLastSession = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.lastSession}`, { params }).then(callback).catch(error).finally(next);
};

const GetRebalancingEvents = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.rebalancingEvents}`, { params }).then(callback).catch(error).finally(next);
};

const GetSiteOverview = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.siteOverview}`, { params }).then(callback).catch(error).finally(next);
};

const GetChargingProfiles = (id, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.chargingProfiles}/${id}`).then(callback).catch(error).finally(next);
};

const GetChargers = (params, start, callback, error, next) => {
    start();
    return HttpClient.get(`${PATH.charger}`, { params }).then(callback).catch(error).finally(next);
};

export const SCService = {
    CreateTag,
    UpdateTag,
    GetAllTags,
    DeleteTag,
    CreateGroup,
    UpdateGroup,
    GetAllGroups,
    DeleteGroup,
    Overview,
    LastReported,
    GetSessionsData,
    FetchSessionInfo,
    CancelProfile,
    GetSignals,
    SendChargingProfile,
    GetChargerGroup,
    GetLogs,
    GetLastSession,
    GetRebalancingEvents,
    GetSiteOverview,
    GetChargingProfiles,
    GetChargers
};
